export const RECAPTCHA_ERROR = "Error when trying to verify recaptcha"

export const handleReCaptchaVerify = async (recaptcha, setRecaptchaRating) => {
  if (!recaptcha) {
    console.log("Execute recaptcha not yet available")
    return
  }

  if (typeof window !== "undefined") {
    try {
      const token = await recaptcha.execute("submit")
      const response = await fetch(`/api/recaptcha-check`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      }).then((res) => res.json())

      setRecaptchaRating(response.score)
    } catch (error) {
      console.error(RECAPTCHA_ERROR, error)
    }
  }
}
